/** Kurzer Hinweis für Rezeption, wenn Stripe einen Checkout nicht als bezahlt gemeldet hat. */

export function stripePaymentAlert(
  status: string | null | undefined,
  subject: string,
): string | null {
  if (status === "failed") {
    return `${subject}: Die Zahlung ist fehlgeschlagen. Es wurde kein Geldeingang verbucht.`;
  }
  if (status === "expired") {
    return `${subject}: Die Stripe-Sitzung ist abgelaufen, ohne dass bezahlt wurde.`;
  }
  if (status === "processing") {
    return `${subject}: Die Bank hat die Zahlung noch nicht bestätigt.`;
  }
  return null;
}
